import React, { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Modal,
  Paper,
  Typography,
  Stack,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Carousel from "react-material-ui-carousel";

import IMG_WELCOME1 from "../../assets/img/onboarding-tutorial-01.jpg";
import IMG_WELCOME2 from "../../assets/img/onboarding-tutorial-02.jpg";
import IMG_WELCOME3 from "../../assets/img/onboarding-tutorial-03.jpg";


export default function WelcomeOnboardModal({
  visible,
  onClose,
  id,
}) {
  const theme = useTheme();

  const [index, setIndex] = useState(0);
  const [dontShow, setDontShow] = useState(false);

  const items = [
    {
      title: 'Pre-Date Onboarding',
      image: IMG_WELCOME2,
      description: "This is your Date Onboarding section. Customize a Welcome Pack email to send to clients after their booking is approved. Ensure they know the important stuff before the date."
    },
    {
      title: 'Helpful Reminders',
      image: IMG_WELCOME1,
      description: "A Welcome Pack serves as a refresher and to reinforce what to expect for the date, for example: date etiquette, payment, hygiene, gift ideas, review & cancellation policies."
    },
    {
      title: 'When Time Is Money',
      image: IMG_WELCOME3,
      description: "Sending a Welcome Pack is entirely optional. Used effectively, it can reduce time wasted on answering questions, repetitive emails and discourage last-minute cancellations."
    }
  ];

  // ? Form Handler
  const onChangeCarousel = (e) => {
    setIndex(e);
  };

  const onNext = () => {
    if (index < 2) {
      setIndex(index + 1);
    } else {
      localStorage.setItem(id + "_DONT_SHOW_WELCOME_ONBOARD_TIP", dontShow);
      onClose();
    }
  }

  function Item({ item }) {
    return (
      <Paper sx={{ boxShadow: 'none', height: '320px' }}>
        <Typography id="modal-modal-title" sx={{ fontSize: '1.8rem', fontWeight: 700, textAlign: 'center', color: theme.palette.mode ==="light" ? "#181c32" : "#fff", my: 1 }}>
          {item.title}
        </Typography>
        <Box component="img" src={item.image} sx={{ width: '100%' }} />
        <Typography sx={{ fontSize: '15px', margin: '16px 0', textAlign: 'center', color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>{item.description}</Typography>
      </Paper>
    )
  }

  return (
    <Modal
      open={visible}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minWidth: '360px',
          bgcolor: 'background.paper',
          borderRadius: 4,
          boxShadow: 24,
          padding: '32px 42px',
          '&:focus-visible': {
            outline: 'none',
          }
        }}
      >
        <Grid sx={{ margin: 'auto' }}>
          <Carousel
            index={index}
            animation="slide"
            autoPlay={false}
            onChange={onChangeCarousel}
            activeIndicatorIconButtonProps={{
              style: {
                color: '#009ef7'
              }
            }}
          >
            {items.map((item, i) => <Item key={i} item={item} />)}
          </Carousel>
          <Stack direction="row" justifyContent="space-between">
            <FormControlLabel
              value={dontShow}
              label={<Typography sx={{ fontWeight: 500, fontSize: '0.8rem', color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Don't show this again</Typography>}
              control={<Checkbox checked={dontShow} />}
              onChange={e => setDontShow(prev => !prev)}
            />
            <Button
              onClick={onNext}
              variant="contained"
              sx={{
                padding: '9px 30px',
                fontSize: '14px',
                fontWeight: 500,
                textTransform: 'none',
                color: '#fff'
              }}
            >
              {index < 2 ? 'Next' : 'Finish'}
            </Button>
          </Stack>
        </Grid>
      </Box>
    </Modal>
  );
}

WelcomeOnboardModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
